import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { cn } from "./cn";

/** 「〇〇へ ›」 navigation link used at the end of panels and lists. */
export function MoreLink({ to, children, className }: { to: string; children: ReactNode; className?: string }) {
  return (
    <Link to={to} className={cn("inline-flex items-center gap-0.5 text-sm font-bold text-brand hover:underline", className)}>
      {children}
      <ChevronRight className="size-4" />
    </Link>
  );
}
